import { FC } from 'react';
import { DynamicField } from './DynamicField';
import { DynamicViewField } from './DynamicViewField';
import {
  getDependentFields,
  getSortedFieldSetDataProperties,
} from './utils/display';

const excludedFields = [
  'installationPostCode', // Copied from mainAddress
];

const FieldSet: FC<{
  formSection: any;
  namespace?: string;
  readonly?: boolean;
  definitions: Record<string, any>;
  formData?: any;
}> = ({
  formSection,
  namespace: fieldNamespace,
  readonly,
  definitions,
  formData,
}) => {
  const sortedProperties = getSortedFieldSetDataProperties(
    formSection.properties,
    fieldNamespace
  );

  return Object.entries<any>(sortedProperties).map(
    ([fieldKey, fieldSchema]) => {
      if (excludedFields.includes(fieldKey)) return null;

      const dependentFields = getDependentFields(
        formSection,
        fieldKey,
        fieldNamespace
      );
      const namespaceOverride =
        fieldSchema.json_schema_extra?.namespaceOverride;
      const formKey = [namespaceOverride || fieldNamespace, fieldKey]
        .filter((x) => x)
        .join('.');
      return readonly ? (
        <DynamicViewField
          fieldSchema={fieldSchema}
          key={formKey}
          name={formKey}
          namespace={fieldNamespace}
          definitions={definitions}
          formData={formData}
        />
      ) : (
        <DynamicField
          fieldSchema={fieldSchema}
          key={formKey}
          name={formKey}
          namespace={fieldNamespace}
          definitions={definitions}
          dependentFields={dependentFields}
        />
      );
    }
  );
};

export default FieldSet;
